import React from "react"
import Header from "../components/header"
import Footer from "../components/footer"
import "@fontsource/open-sans"
import "../scss/main.scss"

const Layout = ({ children }) => (
  <>
    <Header />
    <main className="main-body">{children}</main>
    <Footer />
  </>
)

export default Layout
